import React, { FC, useCallback } from 'react';
import { IOuter } from './FilterByButton.types';
import { Popover, Text, TextButton, WixIcons } from '..';
import styles from './FilterByButton.scss';
import { noop } from 'ramda-adjunct';
import { useBoolean } from '../../../utils/hooks/useBoolean';
import classNames from 'classnames';

export const FilterByButton: FC<IOuter> = ({
  label,
  menuContent,
  dataHook,
  onClick = noop,
  forSmartGrid,
  dataFilterType,
  labelStyle = {},
}) => {
  const { value: isMenuOpened, setFalse: closeMenu, toggle: toggleMenu } = useBoolean();

  const handleTextButtonClick = useCallback(
    (event) => {
      toggleMenu();
      onClick(event, !isMenuOpened);
    },
    [onClick, isMenuOpened],
  );

  const textButton = (
    <TextButton
      as="a"
      size="tiny"
      underline="none"
      suffixIcon={<WixIcons.ChevronDownSmall />}
      onClick={handleTextButtonClick}
      dataHook={dataHook}
      data-filter-type={dataFilterType}
    >
      {forSmartGrid ? (
        <Text className={styles.roundedLabelButton} weight="normal" size="small">
          {label}
        </Text>
      ) : (
        label
      )}
    </TextButton>
  );

  return (
    <Popover
      shown={isMenuOpened}
      showDelay={100}
      hideDelay={0}
      placement="bottom"
      onClickOutside={closeMenu}
      moveBy={{ x: -7, y: 3 }}
      showArrow
      animate
      appendTo="viewport"
      zIndex={10000}
    >
      <Popover.Element>
        {forSmartGrid ? (
          <span className={classNames(styles.rounded, styles.new)} style={labelStyle}>
            {textButton}
          </span>
        ) : (
          textButton
        )}
      </Popover.Element>
      <Popover.Content>
        <div className={styles.popoverContent}>{menuContent}</div>
      </Popover.Content>
    </Popover>
  );
};
